import { createReducer, on } from '@ngrx/store';
import * as commonActions from './common.actions';

export interface State {
  toastMessage: string | null;
}

const initialState: State = {
  toastMessage: null,
};

export const commonReducer = createReducer(
  initialState,
  on(commonActions.viewToast, (state, { message }) => ({
    ...state,
    toastMessage: message,
  })),
  on(commonActions.clearToast, (state) => ({
    ...state,
    toastMessage: null,
  }))
);
